














import Vue from 'vue'
import XHeading from '@/components/atoms/XHeading/XHeading.vue'

const gridNum = 12

export default Vue.extend({
  name: 'ItemValue',
  components: { XHeading },
  props: {
    label: {
      type: String,
      required: true,
    },
    labelGridSize: {
      type: Number, // 1...12 in 12 blocks
      default: 6,
    },
    withMark: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    w() {
      const value = gridNum - this.labelGridSize
      return {
        label: `w-${this.labelGridSize}/12`,
        value: `w-${value}/12`,
      }
    },
  },
})
